import { Component } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MyDeqErrorHandler } from "../../../../core/errorHandler";
import { AppService } from "../../../../service/app.service";
import { Utils } from "../../../../shared/Utils";
import { BasePathController } from "../../../components/base-path-component.component";
import { PagecontentSearchResultUSTCRPage } from "./search-result-ust-cr.resourcebundle";

@Component({
  selector: "search-result-ust-cr",
  templateUrl: "./search-result-ust-cr.component.html",
})
export class SearchResultUSTCRComponent extends BasePathController {
  displayBackButton: boolean = false;
  releaseDetails: any;
  releaseIdno: any;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected formBuilder: UntypedFormBuilder,
    public utils: Utils,
    protected appService: AppService,
    protected errorHandler: MyDeqErrorHandler,
    private router: Router
  ) {
    super(
      activatedRoute,
      formBuilder,
      utils,
      appService,
      errorHandler,
      new PagecontentSearchResultUSTCRPage()
    );
    // this.noGetCallOnLoad = true
    this.activatedRoute.params.subscribe((params: Params) => {
      this.releaseIdno = params["releaseIdno"];
    });
    this.setPageLoadServiceName("details/" + this.releaseIdno);
    // this.setPageLoadServiceURL('details')
    this.utils.title = "LEAKING UST CASE INFORMATION";
  }

  /**
   * @whatItDoes - This method will call by @class BaseComponent @function ngOnInit method to set the form as per input received.
   */
  onGetResponse(getResponse: any): void {
    // console.log(this.model)
    this.displayBackButton = true;
    // this.releaseDetails = getResponse.releaseDetails[0]
    if (getResponse) {
      getResponse.releaseDetails = getResponse.releaseDetails
        ? getResponse.releaseDetails.map((x) => {
            x.display_ustcase =
              x.lustNum + "." + this.utils.prepandZero(+x.lustSeq);
            if (x.address) {
              x.display_address =
                x.address + " " + x.city + ", " + x.state + " " + x.zip;
            } else if (x.address && x.suiteApt) {
              x.display_address =
                x.address +
                " " +
                x.suiteApt +
                " " +
                x.city +
                ", " +
                x.state +
                " " +
                x.zip;
            } else {
              x.display_address = x.lattitude + "/" + x.longitude;
            }
            return x;
          })
        : getResponse.releaseDetails;
    }
    this.releaseDetails = getResponse.releaseDetails[0];
  }

  // populateGetURLParams(urlParams: Params, queryParams: Params): any[] {
  //   return [urlParams['releaseIdno']];
  // }
  // ngOnInit(): void {
  //   this.displayBackButton = true
  //   console.log(this.model)
  //   // this.model = this.model ? this.model.map(x => {
  //   //   x.lustNumber = x.lustNumber + '.' + this.utils.prepandZero(+x.lustSequeance)
  //   //   x.priortyType = x.priortyType + ' - ' + x.priortyDesc
  //   //   x.classType = x.classType + ' - ' + x.classDesc
  //   //   x.programType = x.programType + ' - ' + x.programDesc
  //   //   return x
  //   // }) : this.model;
  // }

  createForm(): UntypedFormGroup {
    return this.formBuilder.group({});
  }

  // public beforeChange($event: NgbPanelChangeEvent) {
  //   if ($event.nextState === false) { $event.preventDefault() }
  // }

  returnToSearchCriteria() {
    this.router.navigate(["/lust", "search-criteria"]);
  }
}
